// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2e5836eb5a60d72451e79f2a4a2daa7e575ef9bf.chunk.bundle.js";
};